import type { ThemeOptions } from '@material-ui/core';
import { createStyles } from '@material-ui/core';

const styles = (theme: ThemeOptions) => {
  return createStyles({
    hero: {
      position: 'relative',
      overflow: 'hidden',
      padding: '0!important',
      height: '300px',
      '@media (min-width: 992px)': {
        height: '450px'
      },
      marginBottom: '0.7143rem'
    },

    image: {
      backgroundSize: 'cover!important',
      height: '100%',
      width: '100%',
      position: 'absolute',
      float: 'right',
      right: '0',
      top: '0',
      '@media(max-width: 768px)': {
        width: '100% !important'
      }
    },

    gradient: {
      height: '100%',
      width: '100%',
      position: 'absolute',
      '@media (max-width: 768px)': {
        background: 'transparent !important'
      }
    },

    solid: {
      height: '100%',
      width: '100%',
      position: 'absolute'
    },

    heroContainer: {
      height: '100%',
      alignItems: 'center',
      display: 'flex',
      '@media (max-width: 768px)': {
        margin: '0 5%',
        paddingLeft: 0
      }
    },

    heroContent: {
      flexDirection: 'column',
      zIndex: '2',
      color: '#FFFFFF'
    },

    heroAction: {
      fontSize: '1.07143rem',
      margin: 0,
      padding: 0,
      '& > button': {
        display: 'block'
      },
      '@media (min-width: 992px)': {
        display: 'inline-block',
        width: '260px',
        marginRight: '50px',
        padding: '0.179rem 0.357rem'
      }
    },

    title: {
      color: '#FFFFFF',
      margin: 0,
      '@media (min-width: 992px)': {
        margin: '5px 0',
        '& > br': {
          display: 'none'
        }
      }
    },

    buttonSubtitle: {
      '@media(max-width:992px)': {
        margin: '0.714rem 0'
      }
    }
  });
};
export default styles;
